/**
 * Controller: layoutsMembershipCardsDeleteModal
 */
angular.module('acme.view.application.layouts.membership.cards.deleteModal.controllers', [
  'ui.bootstrap'
])
.controller('LayoutsMembershipCardsDeleteModalController', [ '$scope', '$uibModalInstance', 'currentLayout', function($scope, $uibModalInstance, currentLayout) {

    $scope.model = {};

    $scope.init = function() {
      if (currentLayout) {
        $scope.model = currentLayout;
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.done = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

}]);
